import { useState, useEffect } from "react";
import { API_URL, scroll, getValFromLS } from "../../helpers";

import Hdg from "../../components/Hdg";
import Alert from "../../components/Alert";

import Nav from "../Nav";

import HotelNav from "./HotelNav";
import HotelCsvForm from "./HotelCsvForm";

const Csv = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	useEffect(() => {
		const init = async () => {
			const token = getValFromLS("vtoUserToken")
				? getValFromLS("vtoUserToken")
				: "";
			const url = new URL(`${API_URL}/admin/hotelCsvInit`);
			const params = {
				token,
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setDetails({
						types: json.types,
						dates: json.dates,
						organizations: json.organizations,
					});
					setUser({ ...json.user });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Hotel Management" admin={true} />
						<HotelNav selected="csv" />
						<HotelCsvForm
							types={details.types}
							dates={details.dates}
							organizations={details.organizations}
							token={getValFromLS("vtoUserToken")}
						/>
						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={0} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Csv;
